module.exports = __webpack_public_path__ + "img/carousel3.11b9ef89.webp";